import React, { memo } from 'react';
import PlayerTimelineButton from './PlayerTimelineButton';
import { useRemotionPlayerPause } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerPause';

function PlayPause() {
  const { isPlaying, pause, play } = useRemotionPlayerPause();
  return (
    <PlayerTimelineButton
      tooltipTitle={isPlaying ? 'Pause' : 'Play'}
      buttonId="play-pause-button"
      onClick={() => {
        if (isPlaying) {
          pause();
        } else {
          play();
        }
      }}
      iconName={isPlaying ? 'IconPlayerPause' : 'IconPlayerPlay'}
    />
  );
}
export default memo(PlayPause);
